
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useTranslation } from "react-i18next";
import { trackAuthAction } from "@/utils/analytics";

interface MethodTabsProps {
  authMethod: "password" | "otp" | "register";
  setAuthMethod: (method: "password" | "otp" | "register") => void;
  resetForm: () => void;
}

export const MethodTabs = ({ authMethod, setAuthMethod, resetForm }: MethodTabsProps) => {
  const { t } = useTranslation();
  
  return (
    <Tabs 
      value={authMethod} 
      onValueChange={(value) => {
        const newMethod = value as "password" | "otp" | "register";
        trackAuthAction("switch_method", "success", `to_${newMethod}`);
        setAuthMethod(newMethod);
        resetForm();
      }}
      className="w-full"
      defaultValue="otp"
    >
      <TabsList className="grid w-full grid-cols-3" style={{ backgroundColor: "#C5D5F9" }}>
        <TabsTrigger value="otp">{t("auth.otpLogin")}</TabsTrigger>
        <TabsTrigger value="password">{t("auth.password")}</TabsTrigger>
        <TabsTrigger value="register">{t("auth.register")}</TabsTrigger>
      </TabsList>
    </Tabs>
  );
};
